import React, { forwardRef, useImperativeHandle } from 'react';
import { Form, Input, Button } from 'antd';
import '../index.less';

export const ProviderForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const onFinish = () => {
    props.searchFn();
  };
  const onReset = () => form.resetFields();
  useImperativeHandle(ref, () => ({ form }));

  return (
    <div className='erp-list-form'>
      <Form form={form} name="provider" layout="inline" onFinish={onFinish}>
        <Form.Item name="rel_company_name" label='供应商名称：' className='erp-list-form-label'>
          <Input placeholder="请输入供应商名称" />
        </Form.Item>
        <Form.Item name="primary_code" label='ERP公司编码：' className='erp-list-form-label' >
          <Input placeholder="请输入ERP公司编码" />
        </Form.Item>
        <Form.Item name="sub_code" label='ERP公司二级细分：' className='erp-list-form-label'>
          <Input placeholder="请输入ERP公司二级细分" />
        </Form.Item>
        <Form.Item>
          <Button className='erp-list-form-btn' type='primary' htmlType="submit"> 查询 </Button>
        </Form.Item>
        <Form.Item>
          <Button className='erp-list-form-btn' onClick={onReset}> 重置 </Button>
        </Form.Item>
      </Form>
    </div>
  );
});